import React, { useState, useEffect, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { enUS } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import './FootballlogDatePicker.css';

type CustomInputProps = {
  value?: string;
  onClick?: () => void;
  className?: string;
};

interface FootballlogDatePickerProps {
  propsDateString?: string;
  onChangeDate?: (date: Date | null) => void;
}

const FootballlogDatePicker: React.FC<FootballlogDatePickerProps> = ({ propsDateString, onChangeDate }) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    onChangeDate && onChangeDate(date);
  };

  useEffect(() => {
    // console.log(new Date(propsDateString))
    setSelectedDate(propsDateString ? new Date(propsDateString) : null);
  }, [propsDateString]);

  // カスタム入力コンポーネントの型安全な実装
  const ExampleCustomInput = forwardRef<HTMLButtonElement, CustomInputProps>(function ExampleCustomInput(
    { value, onClick },
    ref
  ) {
    return (
      <button type="button" className="flex items-center text-gray-500 hover:text-blue-500" onClick={onClick} ref={ref}>
        <div className="font-footballlog italic text-base font-bold">{value || '日付を選択'} </div>
        <svg
          className="w-4 h-4 ms-1 "
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 10h16m-8-3V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Zm3-7h.01v.01H8V13Zm4 0h.01v.01H12V13Zm4 0h.01v.01H16V13Zm-8 4h.01v.01H8V17Zm4 0h.01v.01H12V17Zm4 0h.01v.01H16V17Z"
          />
        </svg>
      </button>
    );
  });

  return (
    <div className="date-picker-container">
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        locale={enUS}
        minDate={new Date('2020-01-01')}
        dateFormat="yyyy-MM-dd"
        popperPlacement="bottom-end"
        renderCustomHeader={({
          date,
          // changeYear,
          // changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled
        }) => (
          <div className="flex justify-between items-center px-8">
            <button
              onClick={decreaseMonth}
              className="text-green-600 hover:bg-gray-200 rounded p-1"
              disabled={prevMonthButtonDisabled}>
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m15 19-7-7 7-7"
                />
              </svg>
            </button>
            <div className="flex flex-col">
              <div className="text-green-600 text-base leading-none">{date.getFullYear()}</div>
              <div className="text-green-600 text-2xl leading-none">{String(date.getMonth() + 1).padStart(2, '0')}</div>
            </div>
            <button
              onClick={increaseMonth}
              className="text-green-600 hover:bg-gray-200 rounded p-1"
              disabled={nextMonthButtonDisabled}>
              <svg
                className="w-4 h-4"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m9 5 7 7-7 7"
                />
              </svg>
            </button>
          </div>
        )}
        customInput={<ExampleCustomInput />}
      />
    </div>
  );
};

export default FootballlogDatePicker;
